<script setup lang="ts">
import Popover from 'primevue/popover';
import TopBarIconButton from './TopBarIconButton.vue';
import AppTile from './AppTile.vue';
import { useTopBarPopover } from './useTopBarPopover';
import { getPlatformApps } from '@/utils';
import spDataMark from '@/assets/sp-data-icon.svg';
import spMark from '@/assets/sp-icon.svg';

// The platform switcher. The current app is listed alongside the others and marked, so the bar
// always shows which platform you are in (ENG-7346).
const apps = getPlatformApps(spDataMark, spMark);

const { popover, toggle, alignToTrigger } = useTopBarPopover();
</script>

<template>
  <TopBarIconButton icon="grid-round" label="Apps" @click="toggle" />

  <Popover ref="popover" @show="alignToTrigger">
    <div class="apps-menu">
      <AppTile v-for="app in apps"
        :key="app.id"
        :label="app.name"
        :logo="app.logo"
        :href="app.url"
        :caption="app.current ? 'Current' : ''"
        :highlighted="app.current"
        :open-in-new-tab="!app.current"
        :aria-current="app.current ? 'page' : undefined" />
    </div>
  </Popover>
</template>

<style scoped lang="scss">
.apps-menu {
  display: grid;
  grid-auto-flow: column;
  gap: 4px;
}
</style>
